<template>
    <div class="app-inner" id="previewCourse">
           <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="$util.reback('/Course')">
            返回
            </div>
            </div>
            <div class="iframeOuterDiv">
                <div class="f-default-product">
                       <div class="module-headline">
                            预览课程
                        </div>
                        <div class="product-container">
                             <div class="product-card" @click="openDetail">
                                <img :src="item.logo" alt="">
                                  <div class="product-card-item-wrap">
                                    <div class="card-name">{{item.title}}</div>
                                    <div class="card-description">{{item.introduction}}</div>
                                    <div class="WordsLink_word-wrap">
                                        <div class="wrap-price">
                                            <div v-if="item.payType == 1" style="color:red">免费</div>
                                            <div v-else class=" flex align-cen">
                                                <div>
                                                        <span style="color:red;font-size:20px">¥{{item.skuList[0].salePrice}}起</span> 
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mft wrap-len" style="color:#b4b7c1;font-size:13px">已更新 {{item.chapterNum}}期</div>
                                    </div>
                                </div>
                             </div>
                        </div>
                </div>
            </div>
        </div>
</template>
<script>
import {prevoewCpurseList} from "@/api/index/index"  //获取课程详情
export default {
    name:'',
    data() {
        return {
            item:{}
        }
    },
    created() {
        this.getList()
    },
    methods: {
        // 打开详情
        openDetail(){
            this.$router.push(
                {
                    name:'previewCourseDetail',
                    query:{
                        id:this.$route.query.id
                    }
                }
            )
        },
        getList(){
           prevoewCpurseList({id:this.$route.query.id}) 
           .then(res =>{
            console.log(res)
           this.item = res.data
           })
        },
    },
}
</script>
<style lang="scss" scoped>
#previewCourse{
    position: relative;
    height: calc(100vh - 200px);
      .iframeOuterDiv {
    max-width: 1344px;
    margin: 0 auto;
    height: auto;
    min-height: auto;
    padding: 20px 32px 0;
    box-sizing: border-box;
    .hotRecommend_container {
      margin: 22px 0 30px;
      width: 100%;
      height: 22px;
      line-height: 22px;
      cursor: default;
      font-size: 0;
      font-family: Microsoft YaHei;
      font-weight: 400;
    }
    .f-default-product{
    display: block;
    width: 100%;
    height: auto;
    text-align: left;
    .module-headline{
    height: 44px;
    line-height: 24px;
    padding-bottom: 20px;
    color: #333;
    box-sizing: border-box;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 20px;
    position: relative;
    }
    .module-headline::before{
        content: "";
    position: relative;
    top: 5px;
    display: inline-block;
    vertical-align: top;
    margin-right: 8px;
    width: 4px;
    height: 16px;
    background: #2893f1;
    border-radius: 3px;
    }
    .product-container{
        margin-bottom: 4px;
        width: 100%;
      .product-card{
        cursor: pointer;
        width: calc((100% - 3 * 32px) / 4);
            position: relative;
            margin: 0 20px 20px 0;
            display: inline-block;
            vertical-align: top;
            max-width: 296px;
            min-width: 260px;
            background-color: #fff;
            box-shadow: 0 4px 20px rgba(19,19,51,0.04);
            border-radius: 4px;
            z-index: 1;
            font-size: 0;
            font-family: Microsoft YaHei;
            font-weight: 400;
            transition: box-shadow .15s;
            img{
                width: 100%;
                height: 150px;
                object-fit: cover;
                border-radius: 4px 4px 0 0;
            }
            .product-card-item-wrap{
             padding: 12px 16px 16px;
             .card-name{
                width: 100%;
                margin-bottom: 2px;
                overflow: hidden;
                color: #161616;
                font-weight: 600;
                font-size: 16px;
                line-height: 26px;
                white-space: nowrap;
                text-overflow: ellipsis;
             }
             .card-description{
                display: -webkit-box;
                margin-bottom: 12px;
                overflow: hidden;
                color: #b4b7c1;
                font-size: 14px;
                line-height: 22px;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
             }
             .WordsLink_word-wrap{
                color: #2893f1;
                font-size: 14px;
                line-height: 22px;
                cursor: pointer;
                span{
                        display: inline-block;
                    font-size: 13px;
                    margin-left: 4px;
                }
             }
            }
      }  
    }
    .appcennone{
    margin: 50px auto;
    width: 370px;
    height: 280px;
    .portal_def_icon{
      width: 350px;
      height: 206px;
    background: url('../../../assets/images/shopOrderList_default.png') no-repeat 0 0;
    margin: 0 auto;
    }
    .portal_def_subHeadline{
      color: #90909e;
    font-size: 16px;
        display: block;
    width: 100%;
    text-align: center;
    font-size: 14px;
    line-height: 32px;
    margin-bottom: 6px;
    }
    }
    }
  }
}
</style>